// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"872f4ef8ccd2a639fcd3","816":"872f4ef8ccd2a639fcd3"}[chunkId] + ".min.css";
};